import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { memo, useMemo } from "react";
import { AssetModalMobileLayout } from "~/components/AssetModal/AssetModalMobileLayout";
import { MobileHeader } from "~/components/AssetModal/components/MobileHeader";
import { MobileCommentsPanelWrapper } from "~/components/AssetModal/MobileTabNavigation/components/MobileCommentsPanelWrapper";
import { MobileCommentsTab } from "~/components/AssetModal/MobileTabNavigation/components/MobileCommentsTab";
import { PublicMobileVersionsPanelWrapper } from "~/components/AssetModal/MobileTabNavigation/MobileVersionsPanelWrapper/PublicMobileVersionsPanelWrapper";
import { useCloseAssetModal } from "~/components/AssetModal/shared/useCloseAssetModal";
import { PublicImageVisualizer } from "~/components/AssetModal/Visualizer/ImageVisualizer/PublicImageVisualizer";
import { PublicPDFVisualizer } from "~/components/AssetModal/Visualizer/PDFVisualizer/PublicPDFVisualizer";
import { MobileVersionsTab } from "~/components/PrivateAssetModal/components/MobileVersionsTab";
import { PublicAssetModalInfoPanel } from "~/components/PublicAssetModal/components/PublicAssetModalInfoPanel";
import { PublicComments } from "~/components/PublicAssetModal/components/PublicCommentsPanel";
import { PublicMobileEllipsisMenu } from "~/components/PublicAssetModal/components/PublicMobileEllipsisMenu";
import { PublicPreviousAndNextArrows } from "~/components/PublicAssetModal/components/PublicPreviousAndNextArrows";
import { PublicVideoVisualizer } from "~/components/PublicAssetModal/components/PublicVideoVisualizer";
import { usePublicPermissions } from "~/components/PublicPermissionsProvider";
import { AssetModalPanel, useAssetModalPanelContext } from "~/providers/AssetModalPanelContextProvider";
import { canSeeAssetVersions, canViewAssetDiscussions } from "~/utils/permissions/assetPermissions";
export const PublicBoardAssetModalMobileLayout = /*#__PURE__*/ memo(()=>{
    const { panel, hidePanel } = useAssetModalPanelContext();
    const { closeAssetModal } = useCloseAssetModal();
    const { permissions } = usePublicPermissions();
    const canViewComments = canViewAssetDiscussions(permissions);
    const canViewAssetVersions = canSeeAssetVersions(permissions);
    const content = useMemo(()=>/*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                panel === AssetModalPanel.COMMENTS && canViewComments ? /*#__PURE__*/ _jsx(MobileCommentsPanelWrapper, {
                    onClose: hidePanel,
                    CommentsPanel: /*#__PURE__*/ _jsx(PublicComments, {})
                }) : panel === AssetModalPanel.VERSIONS && canViewAssetVersions ? /*#__PURE__*/ _jsx(PublicMobileVersionsPanelWrapper, {
                    onClose: hidePanel
                }) : null,
                /*#__PURE__*/ _jsx(PublicAssetModalInfoPanel, {
                    permissions: permissions
                })
            ]
        }), [
        canViewAssetVersions,
        canViewComments,
        hidePanel,
        panel,
        permissions
    ]);
    const tabs = useMemo(()=>/*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                canViewComments && /*#__PURE__*/ _jsx(MobileCommentsTab, {}),
                canViewAssetVersions && /*#__PURE__*/ _jsx(MobileVersionsTab, {}),
                /*#__PURE__*/ _jsx(PublicMobileEllipsisMenu, {})
            ]
        }), [
        canViewAssetVersions,
        canViewComments
    ]);
    const header = useMemo(()=>/*#__PURE__*/ _jsx(MobileHeader, {
            onClose: closeAssetModal
        }), [
        closeAssetModal
    ]);
    return /*#__PURE__*/ _jsx(AssetModalMobileLayout, {
        PreviousAndNextArrows: PublicPreviousAndNextArrows,
        PDFVisualizer: PublicPDFVisualizer,
        VideoVisualizer: PublicVideoVisualizer,
        ImageVisualizer: PublicImageVisualizer,
        tabs: tabs,
        panel: content,
        header: header
    });
});
PublicBoardAssetModalMobileLayout.displayName = "PublicBoardAssetModalMobileLayout";
